import travelIndex from '@/views/travel/travelIndex.vue'

export default {
  path: '/travel',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'travelIndex',
      name: 'travelIndex',
      component: travelIndex
    },


  ]
}
